import type { Request } from '../../../types';

export interface FeedbackInitialProps {
  formData: Record<string, unknown>;
  updateFormData: (field: string, value: string | number) => void;
  disabled?: boolean;
  requestId?: string | number | null;
  isOnline?: boolean;
}

export interface FeedbackPersistedProps {
  request: Request;
  isEditing: boolean;
  editedData: Record<string, unknown>;
  updateEditedData: (field: string, value: string | number) => void;
  showFullDetails?: boolean;
  showViewToggle?: boolean;
  isAdvancedView?: boolean;
  onToggleView?: () => void;
  isOnline?: boolean;
}

export type FeedbackProps = FeedbackInitialProps | FeedbackPersistedProps;

export function isFeedbackPersistedProps(
  p: FeedbackProps,
): p is FeedbackPersistedProps {
  return 'request' in p && (p as FeedbackPersistedProps).request != null;
}
